import { apiRequest } from './core/client';
import { ThreadSchema, parseWithSchema, parseArrayWithSchema, type Thread } from './schemas';

export type { Thread };

// ============================================================================
// Thread Fetching
// ============================================================================

export interface FetchThreadsOptions {
  limit?: number;
  offset?: number;
  signal?: AbortSignal;
  folderId?: string;
}

export async function fetchThreads(
  accountId: string,
  options: FetchThreadsOptions = {}
): Promise<Thread[]> {
  const data = await apiRequest<unknown[]>({
    path: '/threads',
    accountId,
    query: {
      folder: options.folderId,
      limit: options.limit,
      offset: options.offset,
    },
    signal: options.signal,
  });

  return parseArrayWithSchema(ThreadSchema, data, 'fetchThreads');
}

export async function fetchThread(accountId: string, threadId: string): Promise<Thread> {
  const data = await apiRequest<unknown>({
    path: `/threads/${encodeURIComponent(threadId)}`,
    accountId,
  });
  return parseWithSchema(ThreadSchema, data, 'fetchThread');
}

// (archiveThread was deleted — dead code since the engine took over thread
// archiving via per-message moves; grep-verified zero callers, N26.)

// ============================================================================
// Participant Conversation
// ============================================================================

export async function fetchParticipantConversation(
  accountId: string,
  participantId: string
): Promise<Thread> {
  const data = await apiRequest<unknown>({
    path: `/participants/${encodeURIComponent(participantId)}/conversation`,
    accountId,
  });
  return parseWithSchema(ThreadSchema, data, 'fetchParticipantConversation');
}
